import "./ChiropractorNicosiaClinic.module.css";
import Header from "@/reusable_sections/Header";
import LeadershipPartnershipOverview from "./sections/LeadershipPartnershipOverview";
import ContactDetails from "./sections/ContactDetails";
import ServicesAtThisLocation from "./sections/ServicesAtThisLocation";
import LocalAreaContent from "./sections/LocalAreaContent";
import Kundeanmeldelser from "./sections/Kundeanmeldelser";
import AccountFaqs from "./sections/AccountFaqs";
import PrimaryCallToAction from "./sections/PrimaryCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ChiropractorNicosiaClinicPage() {
  return <div>
      <Header />
      <LeadershipPartnershipOverview />
      <ContactDetails />
      <ServicesAtThisLocation />
      <LocalAreaContent />
      <Kundeanmeldelser />
      <AccountFaqs />
      <PrimaryCallToAction />
      <Footer />
    </div>;
}